import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrmSearchRoutingModule } from './crm-search-routing.module';
import { CrmSearchComponent } from './crm-search.component';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    CrmSearchComponent
  ],
  imports: [
    CommonModule,
    CrmSearchRoutingModule,
    SharedModule
    
  ],exports:[
    CrmSearchComponent
  ]
})
export class CrmSearchModule { }
